import React from "react";
import { Clock, AlertTriangle } from "lucide-react";

const DAY = 86400000;
export const EXPIRY_WARN_DAYS = 7;

export const isPendingReferee = (c) => c.referral_status === "pending" && !c.referral_referee_tx
  && !!c.referral_expires_at && new Date(c.referral_expires_at) >= new Date();

const msLeft = (iso) => (iso ? Math.max(0, new Date(iso) - Date.now()) : null);
const isUrgent = (ms) => ms !== null && ms < EXPIRY_WARN_DAYS * DAY;
const label = (ms) => {
  const d = Math.floor(ms / DAY);
  return d < 1 ? "under 1 day" : `${d} day${d === 1 ? "" : "s"}`;
};

// Small chip for members-list rows: time left for a pending referral
export function ReferralDaysChip({ expiresAt, testid }) {
  const ms = msLeft(expiresAt);
  if (ms === null) return null;
  return (
    <span className="inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap"
          style={isUrgent(ms) ? { background: "rgba(220,38,38,0.1)", color: "#b91c1c", border: "1px solid rgba(220,38,38,0.3)" }
                              : { background: "rgba(201,162,75,0.14)", color: "#8a6a1f", border: "1px solid rgba(201,162,75,0.4)" }}
          data-testid={testid}>
      <Clock className="h-3 w-3" /> Referral · {label(ms)} left
    </span>
  );
}

// Warning box on member cards when a pending referral expires within 7 days
export function ReferralExpiryAlert({ expiresAt, text, testid }) {
  const ms = msLeft(expiresAt);
  if (!isUrgent(ms)) return null;
  return (
    <div role="alert" className="flex items-start gap-2 rounded-lg px-3 py-2 text-xs"
         style={{ background: "rgba(220,38,38,0.08)", color: "#b91c1c", border: "1px solid rgba(220,38,38,0.3)" }}
         data-testid={testid}>
      <AlertTriangle className="h-4 w-4 flex-shrink-0 mt-px" />
      <span>{text(label(ms), new Date(expiresAt).toLocaleDateString())}</span>
    </div>
  );
}
